// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"7e6fb398","667":"f99b28d0","734":"6bdcaafd","771":"ce026933","995":"c25f3972"}[chunkId] + ".chunk.css";
};